import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { ExternalLink } from "@redotech/redo-web/link";
import { Text } from "@redotech/redo-web/text";
import { isDef } from "@redotech/util/checks";
import { memo, useContext, useState } from "react";
import { OutboundRateOption } from "../../common/util";
import * as css from "./checkout-rate-section.module.css";
import { LcgUnavailableCard } from "./lcg-unavailable-card";
import { MarginBreakdownModal } from "./margin-breakdown-modal";

export const CheckoutRateSection = memo(function CheckoutRateSection({
  fulfillmentGroups,
  selectedRate,
  requestedShippingService,
  requestedShippingServiceDescription,
}: {
  fulfillmentGroups: readonly FulfillmentGroupData[];
  selectedRate: OutboundRateOption | null;
  requestedShippingService: string;
  requestedShippingServiceDescription: string | undefined;
}) {
  const team = useContext(TeamContext);

  const [marginBreakdownModalOpen, setMarginBreakdownModalOpen] =
    useState(false);

  const showCheckoutOptimizationBreakdown =
    fulfillmentGroups.length === 1 &&
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    !!fulfillmentGroups[0].totalShippingCost.fulfillmentOrdersBreakdown
      ?.length &&
    !!team?.shopifyIntegration?.checkoutOutboundRatesEnabled;

  const lcgUnavailableText = (
    <LcgUnavailableCard fulfillmentGroup={fulfillmentGroups[0]} />
  );

  return showCheckoutOptimizationBreakdown ? (
    <Flex dir="column" gap="sm">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Requested shipping service
      </Text>
      <RedoBadge
        className={css.checkoutRateBadge}
        color="blue"
        text={
          isDef(selectedRate) ? (
            <Flex align="flex-start" dir="column" gap="xxs">
              <Text fontSize="xs" fontWeight="bold">
                {requestedShippingService}
              </Text>
              {requestedShippingServiceDescription && (
                <Text fontSize="xs">{requestedShippingServiceDescription}</Text>
              )}
              <ExternalLink
                className={css.checkoutRateBadgeLink}
                onClick={() => setMarginBreakdownModalOpen(true)}
                showIcon={false}
              >
                View full margin breakdown
              </ExternalLink>
            </Flex>
          ) : (
            "Service selected by customer at checkout."
          )
        }
      />
      {lcgUnavailableText}
      {isDef(selectedRate) && (
        <MarginBreakdownModal
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          fulfillmentGroup={fulfillmentGroups[0]}
          onClose={() => setMarginBreakdownModalOpen(false)}
          open={marginBreakdownModalOpen}
          requestedShippingService={requestedShippingService}
          selectedRate={selectedRate}
        />
      )}
    </Flex>
  ) : (
    <Flex dir="column" gap="xxs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Requested shipping service
      </Text>
      <Text fontSize="xs" fontWeight="medium" textColor="primary">
        {`${requestedShippingService}${requestedShippingServiceDescription ? `: ${requestedShippingServiceDescription}` : ""}`}
      </Text>
      {lcgUnavailableText}
    </Flex>
  );
});
